export enum UserType {
  User = 1,
  Auto = 2,
}

export const messageOriginMap: Record<string, UserType> = {
  User: UserType.User,
  Auto: UserType.Auto,
};
export enum MessageType {
  text = 1,
  image = 2,
  video = 3,
  textList = 4,
  feedbackCard = 5,
  uploadDrafts = 7,
  questionList = 8,
  orderCard = 9,
  refundCard = 10,
}
export enum OrderStatusEnum {
  /** 支付成功 */
  PAY_SUCCESS = 1,
  /** 退款成功 */
  REFUND_SUCCESS = 3,
  /** 扣款失败 */
  DEDUCT_FAIL = 4,
  /** 退款中 */
  REFUND_PROCESSING = 6,
}
export const ORDER_DETAIL =
  "kwaiying://krn?bundleId=KyVipPayment&componentName=OrderDetail";
